import styled from 'styled-components';

export const FlexContent = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 2rem;
  margin-right: auto;
  flex: 1;
  .MuiOutlinedInput-root {
    min-width: 200px;
  }
  .MuiOutlinedInput-root.Mui-error {
    margin-top: 16px;
  }
  .long-error {
    .MuiOutlinedInput-root {
      margin-top: 50px;
    }
  }
  > :nth-child(1) {
    flex: 1;
  }
  > :nth-child(2) {
    flex: 3;
  }
`;
